import React from "react";
import { Button } from "antd-mobile";
import shiyongzu from "./shiyongzu.jpg";

class onTrial extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  render() {
    return (
      <div
        className="onTrialBox"
        style={{ minHeight: "100vh", background: "#f3f4f5" }}
      >
        <img src={shiyongzu} style={{ width: "100%" }} />
      </div>
    );
  }
}
export default onTrial;



// WEBPACK FOOTER //
// ./src/onTrial/index/index.js